import React, { useEffect, useState } from "react"
import { View, StyleSheet, Text, ScrollView, Dimensions, TouchableOpacity, Alert } from "react-native"
import { Button } from "@Components/CustomButton/Button"
import { ContainerGlogal } from "@Components/ContainerGlogal"
import { InputGroup } from "@Components/Input/InputGroups"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors } from "@Constants/baseStyles"
import { LoginService } from "@Services/Login.Service"
import { Ionicons } from "@expo/vector-icons"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { useRecoilState, useSetRecoilState } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { UserService } from "@Services/User.service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import CustomCheckBox from "@Components/CustomCheckBox/CustomCheckBox"
import { CustomRadio } from "@Components/CustomRadio/CustomRadio"
import { TextInputMask } from "react-native-masked-text"
import { Divider } from "react-native-paper"
import moment from "moment"
import { TransformToLowerCase, dbDateFormat, isValidEmail, localDateFormat, validDate } from "@Utils/utils"

const defaultpasswords = {
    oldPassword: "",
    password: "",
    retypePassword: ""
}
const { height } = Dimensions.get("screen")

export const EmailAdress = ({ navigation }) => {
    const [loading, setLoading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [passwords, setPasswords] = useState(defaultpasswords)
    const [user, setUser] = useRecoilState(userAtom)
    const [newMail, setNewMail] = useState("")

    const canSubmitPersonnalData = () => {
        return isValidEmail(newMail)
    }

    useEffect(() => {
        if (user && user?.birthDate) {
            setUser((old) => ({
                ...old,
                birthDate: user?.birthDate
                    ? moment(user.birthDate, dbDateFormat).format(localDateFormat)
                    : moment(new Date(), dbDateFormat).format(localDateFormat)
            }))
        }
    }, [])

    const performUpdatePersonalData = () => {
        setLoading(true)
        const newUserData = { ...user, email: newMail }
        UserService.updateUserData(user.id, newUserData)
            .then((response) => {
                setLoading(false)
                ShowToast({ type: "success", message: "vos informations ont été enregistrées" })
            })
            .catch((e) => {
                ShowToast({ type: "error", message: "oops, une erreur est survenue" })
                setLoading(false)
            })
    }

    const RenderEmailForm = () => {
        return (
            <>
                <BreeSerifText
                    style={{ textAlign: "left", fontSize: 20, color: baseColors.green.primary, paddingTop: 10 }}
                >
                    Modifier mon adresse mail
                </BreeSerifText>
                <OpenSansText>Renseignez votre nouvelle adresse mail.</OpenSansText>
                <View style={{ marginTop: 30 }}>
                    <InputGroup
                        disabled={true}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, email: text }))
                        }}
                        valid={user.email.length > 0}
                        value={user.email}
                        validation_message={"obligatoire"}
                        label={"Adresse email actuelle"}
                        placeholder={"example@mail.com"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setNewMail(text)
                        }}
                        valid={isValidEmail(newMail)}
                        value={newMail}
                        validation_message={"adresse mail invalide"}
                        label={"Nouvelle adresse mail"}
                        placeholder={"Entrez votre adresse mail"}
                    />
                    {/* <View style={{ display: "flex", flexDirection: "row", marginTop: 10, marginBottom: 20 }}>
                        <CustomRadio
                            label={"Homme"}
                            value={1}
                            checked={user.sex === 1}
                            setValue={(value) => {
                                setUser((old) => ({ ...old, sex: value }))
                            }}
                        ></CustomRadio>
                        <View style={{ width: 40 }}></View>
                        <CustomRadio
                            label={"Femme"}
                            checked={user.sex === 0}
                            value={0}
                            setValue={(value) => {
                                setUser((old) => ({ ...old, sex: value }))
                            }}
                        ></CustomRadio>
                    </View>
                    <InputGroup
                        mask={"datetime"}
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, birthDate: text }))
                        }}
                        valid={user?.birthDate ? validDate(user.birthDate) : true}
                        value={user?.birthDate ? user.birthDate : moment(new Date()).format(localDateFormat)}
                        validation_message={"Date invalide"}
                        maxLength={10}
                        label={"Date de naissance"}
                        placeholder={"12/03/1998"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, birthPlace: text }))
                        }}
                        valid={true}
                        value={user.birthPlace}
                        validation_message={""}
                        label={"Lieu de naissance"}
                        placeholder={"Entrez votre lieu de naissance"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, phoneNumber: text }))
                        }}
                        valid={true}
                        value={user.phoneNumber}
                        validation_message={""}
                        label={"Téléphone"}
                        placeholder={"Entrez votre téléphone"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, civility: text }))
                        }}
                        valid={true}
                        value={user.civility}
                        validation_message={""}
                        label={"Civilité"}
                        placeholder={"Français"}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, height: text }))
                        }}
                        valid={true}
                        value={user?.height?.toString()}
                        validation_message={""}
                        label={"Taille en cm"}
                        placeholder={"185 cm"}
                    />

                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, weight: text }))
                        }}
                        valid={true}
                        value={user?.weight?.toString()}
                        validation_message={""}
                        label={"Poids en kg"}
                        placeholder={"80 kg"}
                    />

                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, address: text }))
                        }}
                        valid={true}
                        value={user.address}
                        validation_message={""}
                        label={"Adresse"}
                        placeholder={"15 rue des ..."}
                    />
                    <InputGroup
                        disabled={loading}
                        onChange={(text) => {
                            setUser((old) => ({ ...old, profession: text }))
                        }}
                        valid={true}
                        value={user.profession}
                        validation_message={""}
                        label={"Profession"}
                        placeholder={"Enseignant"}
                    /> */}
                </View>
                <Button
                    disabled={!canSubmitPersonnalData() || loading}
                    loading={loading}
                    onPress={() => {
                        performUpdatePersonalData()
                    }}
                    text="sauvegarder"
                    width="80%"
                    height={45}
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
                <Divider style={{ height: 1, marginTop: 20, marginBottom: 5 }} />
            </>
        )
    }

    return (
        <ContainerGlogal style={{ paddingTop: 10 }}>
            <ScrollView keyboardShouldPersistTaps={"handled"} contentContainerStyle={{ paddingBottom: 80 }}>
                <View style={styles.container}>{RenderEmailForm()}</View>
            </ScrollView>
        </ContainerGlogal>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: 0,
        paddingHorizontal: 20,
        backgroundColor: "white",
        alignContent: "center"
    },
    text: {
        color: baseColors.black,
        textAlign: "justify",
        fontFamily: "BreeSerif",
        fontSize: 16
    }
})
